import {Injectable} from '@angular/core';
import {Video} from "../interfaces/video";

@Injectable({
  providedIn: 'root'
})
export class ServerVideoService {

  constructor() {
  }

  mapRawVideoData(data: any): Video {
    // at this time mapping is the same as on server
    return data;
  }

  getYoutubeNoCookieUrl(video: Video): string {
    return 'https://www.youtube-nocookie.com/embed/' + this.getYoutubeId(video.src) + '?autoplay=0';
  }

  getYoutubeShortsUrl(video: Video): string {
    return 'https://www.youtube.com/embed/' + this.getYoutubeId(video.src);
  }

  getYoutubeIframeStringByVideo(video: Video): string {
    return '<iframe width="560" height="315" src="' + this.getYoutubeNoCookieUrl(video) + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
  }

  getYoutubeIframeShortsStringByVideo(video: Video): string {
    return '<iframe width="560" height="315" src="' + this.getYoutubeShortsUrl(video) + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
  }

  private getYoutubeId(url: string): string | null {
    // Added 'shorts/' to the list of potential ID prefixes
    const regExp = /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
    const match = url.match(regExp);

    return (match && match[1].length === 11) ? match[1] : null;
  }
}
